import { useCallback, useContext, useState } from 'react';
import { Portal } from '../../hybrid/wrappers';
import css from './AgreeModal.module.scss';
import T from '../../common/components/T';
import UserContext from '../../common/utils/getContext';
import { dataSender } from '../../common/utils/router';
import ViewPdf from '../viewPdf/ViewPdf';

export default function AgreeModal({ documents }) {
    const { userToken, lang } = useContext(UserContext);

    const [modal, showModal] = useState(true);
    const sender = useCallback(() => {
        dataSender(
            documents?.meta?.links?.to_sign,
            'POST',
            {
                ids: documents?.data?.filter((item) => item.id)?.map((item) => item.id)
            },
            () => {
                showModal(false);
            },
            () => {},
            userToken,
            lang
        );
    }, [userToken, lang, documents]);

    if (!modal) return null;
    return (
        <Portal>
            <div className={css.modal}>
                <p className={css.modalTitle}>
                    <T
                        textName='agree-modal-title-v1'
                        defaultStr='Для продолжения работы необходимо ознакомиться со следующими документами'
                    />
                </p>

                <ViewPdf documents={documents.data} sender={sender} />
            </div>
        </Portal>
    );
}
